import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../index.js";
import { useNavigate } from "react-router-dom";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import "./LoginStyle.css";
import { SUCCESS } from "../../Utils/constant.js";
import { toast } from "react-toastify";

const Login = () => {
  const [userData, setUserData] = useState({
    email: "",
    password: "",
    mobile: "",
    otp: "",
  });
  const { authLogin, requestOtp, getShopCustomer, loader } = useContext(AuthContext);
  const [isPasswordHide, setIsPasswordHide] = useState(true);
  const [isLoginViaOtp, setIsLoginViaOtp] = useState(false);
  const [otpSuccess, setOtpSuccess] = useState(false);
  const navigate = useNavigate();



  const handleRequest = async () => {
    if (isLoginViaOtp) {
      if (otpSuccess) {
        getShopCustomer(userData);
      } else {
        const resp = await requestOtp(userData.mobile);
        if (resp === SUCCESS) {
          setOtpSuccess(true);
        } else {
          toast.error("This mobile is not registered with us please create new account")
          setOtpSuccess(false);
        }
      }

    } else {
      authLogin(userData);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="login-page-container">
      <h1 className="login-heading">Sign In!</h1>
      <div className="login-body">
        {
          isLoginViaOtp ? <div className="login-field-container">
            <div className="login-field">
              <label htmlFor="mobile">Mobile</label>
              <input
                id="mobile"
                disabled={otpSuccess}
                type="phone"
                placeholder="Enter Mobile Number"
                value={userData.mobile}
                onChange={(e) =>
                  setUserData((prev) => ({ ...prev, mobile: e.target.value }))
                }
              />
            </div>
            {
              otpSuccess &&
              <div className="login-field">
                <label htmlFor="otp">Enter Otp</label>
                <input
                  id="otp"
                  type="text"
                  placeholder={"Enter Otp"}
                  onChange={(e) =>
                    setUserData((prev) => ({ ...prev, otp: e.target.value }))
                  }
                />
              </div>
            }
          </div> :
            <div className="login-field-container">
              <div className="login-field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  placeholder="test@example.com"
                  value={userData.email}
                  onChange={(e) =>
                    setUserData((prev) => ({ ...prev, email: e.target.value }))
                  }
                />
              </div>
              <div className="login-field">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type={isPasswordHide ? "password" : "text"}
                  placeholder={isPasswordHide ? "********" : "Enter Password"}
                  onChange={(e) =>
                    setUserData((prev) => ({ ...prev, password: e.target.value }))
                  }
                />
                <span onClick={() => setIsPasswordHide(!isPasswordHide)}>
                  {isPasswordHide ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </span>
              </div>
            </div>
        }
        <div className="login-btn-container">
          <button
            className="login-btn"
            onClick={handleRequest}
            disabled={loader}
          >
            {isLoginViaOtp ? otpSuccess ? "Login" : "Request OTP" : "Login"}
          </button>
          <button className="login-btn" disabled={loader || otpSuccess} onClick={() => setIsLoginViaOtp(!isLoginViaOtp)}>{isLoginViaOtp ? "Login via Email" : "Login via OTP"}</button>
        </div>
        <p className="login-new-account" onClick={() => navigate("/signup")}>
          Create New Account
        </p>
      </div>
    </div>
  );
};

export { Login };
